let trayaProcessingAnimation = document.getElementById('traya-processing-animation');
var id = getUrlParameter('id'), f_name = "", C_number = "", C_email = "", user__gender = "", user_gender = "", rid = "", caseId = "", selectedStage = 'Stage-1';
var cohort = getUrlParameter('cohort'), variantsID = 0, recommended_products = [], variantsIDs = [];
var prices = 0, doc__fee = 100000, diet__plan = 50000, hair__coach_fee = 50000, month1_total, month1DiscountPrice, month3DiscountPrice, month6DiscountPrice, discount_pricetext = 0;
let successfulFetchCount = 0, totalProducts = 0;
window.userStage = null;

if (id) {
  localStorage.setItem('user-gender', 'male');
  localStorage.setItem('rid', id);
}
id = localStorage.getItem('rid');
if(id === undefined) {
  id = getCookie('syntheticId');
}

const params = new URLSearchParams(window.location.search);
const urlSource = params.get("url_source");
if (urlSource) {
  localStorage.setItem("traya_path_name", urlSource);
}

(function () {
  function sleep(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }
  async function playStageAnimation(userStage, userType) {
    const params = new URLSearchParams(window.location.search);
    const urlSource = params.get("url_source");
    let navType = "navigate";
    const navEntries = performance.getEntriesByType("navigation");
    if (navEntries?.length && navEntries[0].type) {
      navType = navEntries[0].type;
    } else if (performance.navigation) {
      navType =
        performance.navigation.type === 1 ? "reload" :
        performance.navigation.type === 2 ? "back_forward" :
        "navigate";
    }
    // debugger
    const shouldShowFirstLoader =
      (urlSource === "questionsV4_FC" || urlSource === "questionsV5_FC") &&
      navType === "navigate" &&
      userStage !== "Stage-1";
    if (urlSource === "questionsV4_FC" || urlSource === "questionsV5_FC") {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete("url_source");

      // This changes the URL WITHOUT reload
      window.history.replaceState({}, "", cleanUrl.toString());
    }
    const firstLoader = document.getElementById("traya-new-processing-animation");
    const secondLoader = document.getElementById("traya-processing-animation");

    if (shouldShowFirstLoader) {
      if (firstLoader) firstLoader.style.display = "flex";
      if (secondLoader && secondLoader.parentNode) secondLoader.remove();
    } else {
      if (firstLoader) firstLoader.style.display = "none";
      if (secondLoader) secondLoader.style.display = "flex";
    }
    
    const mainSection = document.querySelector(".new_male_container");
    const mainSection2 = document.querySelector(".assessment-wrapper");
    const loader = document.getElementById("traya-new-processing-animation");
    if (!shouldShowFirstLoader) {
      if (mainSection) {
        mainSection.style.display = "block";
        mainSection.classList.remove("prepare", "move-to-top", "visible");
        mainSection.style.opacity = "1";
        mainSection.style.transform = "none";
      }
      if (mainSection2) {
        mainSection2.style.display = "flex";
        mainSection2.classList.remove("visible");
        mainSection2.style.opacity = "1";
        mainSection2.style.transform = "none";
      }
      if (loader) loader.style.display = "none";

      return; 
    }

    let extracted = String(userStage).match(/\d+/);
    let stageNum = extracted ? parseInt(extracted[0], 10) : 1;
    if (stageNum < 1 || stageNum > 5) stageNum = 1;

    const wrapper = document.querySelector(
      userType === "top" ? "#top-view" : "#front-view"
    );

    const images = wrapper ? Array.from(wrapper.querySelectorAll(".stage-img")) : [];
    const bars = Array.from(document.querySelectorAll(".stage-bars .stage"));

    if (!loader || images.length === 0 || bars.length === 0) {
      return;
    }

    const total = Math.max(images.length, bars.length);

    // Reset states
    images.forEach((img, i) => {
      img.classList.remove("lift-up");
      img.style.zIndex = i === 0 ? 2 : 1;
    });

    bars.forEach(bar => {
      bar.classList.remove("active", "bounce", "lift-up");
      bar.style.zIndex = 2;
    });

    function showImage(idx) {
      images.forEach((im, i) => {
        im.classList.remove("hidden");
        im.classList.toggle("visible", i === idx);
      });
    }

    let idx = 0;
    showImage(idx);
    bars[idx].classList.add("active");
    await sleep(150);

    // LOOP ANIMATION
    while (true) {
      bars.forEach(b => b.classList.remove("bounce"));
      bars[idx].classList.add("active", "bounce");
      showImage(idx);

      if (idx + 1 === stageNum) {
        await sleep(650);
        bars[idx].classList.remove("bounce");
        bars[idx].classList.add("lift-up");
        if (images[idx]) images[idx].classList.add("lift-up");

        // PREPARE MAIN SECTION
        if (mainSection) mainSection.classList.add("prepare");

        await sleep(400);
        loader.classList.add("fade-out", "keep-height");
        await sleep(600);
        loader.style.display = "none";

        // SHOW MAIN SECTION
        if (mainSection) {
          mainSection.style.display = "block";
          mainSection.classList.add("visible");

          setTimeout(() => {
            mainSection.classList.remove("prepare");
          }, 100);
          mainSection.classList.add("move-to-top");
        }

        // SHOW SECOND SECTION
        await sleep(600);
        if (mainSection2) {
          mainSection2.style.display = "flex";
          mainSection2.classList.add("visible");
        }

        // HIDE PROCESSING ANIMATION COMPLETELY
        await sleep(100);
        return;
      }

      await sleep(500);

      bars[idx].classList.remove("active", "bounce");
      idx = (idx + 1) % total;
      bars[idx].classList.add("active");
      showImage(idx);

      await sleep(500);
    }
  }

  window.playStageAnimation = playStageAnimation;
})();

(function () {
  if(!id) {
    if(window.location.pathname == '/pages/result4c'){
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      document.location.href= 'https://form.traya.health/questions?cohort=1&source=ResultPage'
    }
  var data_formPage = document.querySelectorAll('[data-formPage]'),
      data_resultPage = document.querySelectorAll('[data-resultPage]'),
      data_resultbtn = document.querySelectorAll('[data-resultbtn]'),
      data_notResult = document.querySelectorAll('[data-notResult]');
    if(data_formPage.length != 0) {
      data_formPage.forEach((formpage) => { formpage.style.display = "block"; });
    }
    if(data_resultPage.length != 0) {
      data_resultPage.forEach((resultpage) => { resultpage.style.display = "none"; });
    }
    if(data_resultbtn.length != 0) {
      data_resultbtn.forEach((resultbtn) => { resultbtn.style.display = "none"; });
    }
    if(data_notResult.length != 0) {
      data_notResult.forEach((notresult) => { notresult.style.display = "block"; });
    }
  }else {
    setotherCookie('syntheticId', id, 30, '.traya.health');
    var data_result = document.querySelectorAll('[data-result]');
    if(data_result.length != 0) {
      data_result.forEach((result) => { result.style.display = "block"; })
    }
  }
  var baseUrls = {
    DEV: 'https://api.dev.hav-g.in/',
    PROD: 'https://api.hav-g.in/'
  };
  var tokens = {
    DEV: { 
      "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
    },
    PROD: { 
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    }
  };
  var token = tokens.PROD;
  var baseUrl = baseUrls.PROD;
  var liveendpoint = 'https://api.dev.hav-g.in/dgReport?id=';
  if (cohort == 2) {
    liveendpoint = baseUrl + 'dgReport/male/v4?id=';
  } else {
    liveendpoint = baseUrl + 'dgReport/male/v4?id=';
  }
  liveendpoint = baseUrl + 'dgReport/male/v4?id=';
  window.addEventListener('DOMContentLoaded', function() {
    clearCart();
    var atcButton = document.querySelectorAll('#add-to-cart-result-page');
    if (atcButton.length !== 0) {
      atcButton.forEach((button) => {
        button.addEventListener('click', function () {
          button.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_clockwise.svg?v=1746524502" class="loader-icon" alt="Loading...">`;
          button.classList.add('loader-added')
          button.disabled = true;
          const addToCartEvent = 'result_add_to_cart';
          const addToCartEventData = { "gender": "Male" };
          Shopify.analytics.publish(addToCartEvent, addToCartEventData);
          setTimeout(() => {
            window.location.href = '/checkout';
          }, 100); 
          setTimeout(() => {
            button.disabled = false;
            button.classList.remove('loader-added');
            button.style.textTransform = 'capitalize';
            button.innerHTML = `<span class="Rmoney_buy mr-1 mr-md-5">Buy Now</span>`;
            button.style.color = '#000';
            // document.querySelector('.template-page.result4 .sticky-btn .result4_buynow .Rmoney_buy').style.color = '#000';
            // document.querySelector('.template-page.result4 .sticky-btn .result4_buynow .Rmoney_buy').style.textTransform = 'capitalize';
          }, 1500);
        });
      });
    }
    
    getMaleResult(liveendpoint, id, token);
  })
})();

async function clearCart(caseId) {
  var _id = caseId || localStorage.getItem('caseId') || '';
  // Fetch cart state first to avoid calling clear.js on an already-empty cart.
  // Excessive clear.js calls on empty carts trigger Cloudflare bot detection on Shopify's CDN.
  let cartCount = 0;
  try {
    const cartState = await fetch('/cart.js').then(r => r.json());
    cartCount = cartState.item_count || 0;
  } catch (e) {
    console.error('Error fetching cart state: ', e);
  }
  if (cartCount === 0) return;

  var formdata = {
    sections: 'cart-drawer'
  };
  await fetch('/cart/clear.js', {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formdata)
  }).then((response) => {
    return response.json();
  }).then((result) => {
    var t = document.querySelector('cart-drawer');
    let cart_drawer = result.sections['cart-drawer'];
    CartDrawerUpdate(t, cart_drawer, drawer=false,0);
  }).catch((error) => {
    console.error('Error: ', error);
  })
}

// CAPI_TRACKING_API code
function trackMetaEvent(response, eventName) {
  function getCookieValue(cookieName) {
    const cookie = document.cookie.split(';').find(c => c.trim().startsWith(cookieName + '='));
    if (!cookie) return null;
    return cookie.trim().split('=').slice(1).join('=');
  }
  
  const fbp = getCookieValue('_fbp');
  const fbc = getCookieValue('_fbc');
  const user_gender = response.gender;
  const email = response.email;
  const phone = response.phone;
  
  const capiBody = {
    eventName: eventName,
    eventTime: Date.now(),
    email: email,
    phone: phone,
    fbc: fbc,
    fbp: fbp,
    url: window.location.href,
    domain: "traya.health",
    gender: user_gender
  };
  
  const CAPI_TRACKING_API = {
    Dev: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  
  const bearerTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };
  
  fetch(`${CAPI_TRACKING_API.PROD}tracking`, { method: 'POST', body: JSON.stringify(capiBody), headers: {
      "Content-Type": "application/json",
      ...bearerTokens.PROD
    }
  });
}

async function getMaleResult(livepoint, id, token) {
  document.body.style.overflow = 'hidden';
  let _fetchedCaseId = '';
  try {
    const response = await fetch(`${livepoint}${id}&isWebsite=true`, {
      headers: token
    });
    const data = await response.json();
    
    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
      }
    };
    const caseId = String(data?.User_Analysis?.case_id).trim();
    _fetchedCaseId = caseId;
    tagClarityCaseId(caseId);
    const userStage = data?.User_Analysis?.stage;
    window.userStage = userStage;
    const validStage = userStage === "Coin Size Patch" || userStage ===  "Heavy Hair Fall" || userStage === "Stage-6";
    console.log("Fetched caseId:", caseId);
    const queryString = window.location.search;

    if (validStage == true) {
      window.location.href = '/pages/result4' + queryString;
      return;
    }
    const stage = data.currentStage.stage;   // "Stage-3"
    const stageValue = Number(stage.match(/\d+/)[0]);

    const frontView      = document.querySelector("#front-view");
    const frontViewStage = document.querySelector("#front-view-stages");

    const topView        = document.querySelector("#top-view");
    const topViewStage   = document.querySelector("#top-view-stages");


    if(data.currentStage.hairLossStageType == "top"){
      topView?.classList.remove('d-none');
      topViewStage?.classList.remove('d-none');
      document.querySelector(".traya-animation-wrapper").style.opacity = 1;
    } else if(data.currentStage.hairLossStageType == "front"){
      frontView?.classList.remove('d-none');
      frontViewStage?.classList.remove('d-none');
      document.querySelector(".traya-animation-wrapper").style.opacity = 1;
    } else {
      frontView?.classList.remove('d-none');
      frontViewStage?.classList.remove('d-none');
      document.querySelector(".traya-animation-wrapper").style.opacity = 1;
    }
    playStageAnimation(data.currentStage.stage, data.currentStage.hairLossStageType);
    setStageProgress(data);
    successRateDataFetch(data);
    ShowContent(data);
    rootCause(data?.root_causes);
    resultMonthKit(data);
    displayProduct(data);
    getProductByHandle(data);
    trackMetaEvent(data.User_Analysis, "Viewed Content");
    displayStageSection(data);
    sectionMonthsExpectetion(data);
    sectionRealStories(data);
    addClickEventListernerToMonthkit();
  } catch (error) {
    console.error('Error: ', error);
    document.body.style.overflow = 'unset';
  } finally {
    await clearCart(_fetchedCaseId);
    checkout();
  }
}

const geneticStageContent = {
  "Stage-2": {
    headline: "Your hair fall is Genetic, but Don't Worry!",
    text: [
      "This is caused by internal hormones attacking your hair follicles.",
      "At your stage, most hair follicles are still active. Starting your customised plan now will show results in 5–6 months."
    ]
  },
  "Stage-3": {
    headline: "Your hair fall is Genetic, but Don't Worry!",
    text: [
      "This is caused by internal hormones attacking your hair follicles.",
      "At your stage, hair follicles are actively shrinking. Start soon to increase your chances of hair regrowth."
    ]
  },
  "Stage-4": {
    headline: "Your hair fall is Genetic, but Don't Worry!",
    text: [
      "This is caused by internal hormones attacking your hair follicles.",
      "Hair fall at this stage can be reversed with consistent, long-term usage of your recommended customised plan."
    ]
  },
  "Stage-5": {
    headline: "Your hair fall is Genetic, but Don't Worry!",
    text: [
      "This is caused by internal hormones attacking your hair follicles.",
      "This stage of hair fall is difficult to reverse, but is possible with long-term consistent usage of your recommended customised plan."
    ]
  }
};

const stageDescriptions = {
  "Stage-1": {
    text: "Stage 1 male pattern hair fall shows slight thinning at the crown or front. Early Haircare can easily prevent further damage."
  },
  "Stage-2": {
    text: "Stage 2 hair fall is caused by internal hormone attacking hair follicles. Most follicles are still active — best time to start treatment."
  },
  "Stage-3": {
    text: "Stage 3 hair fall means more follicles are affected. However many are still active with a great chance for regrowth."
  },
  "Stage-4": {
    text: "Stage 4 hair fall occurs when follicles shrink due to internal hormones. Regrowth is possible with long-term consistency."
  },
  "Stage-5": {
    text: "Stage 5 hair fall shows significant weakening of follicles. Regrowth is difficult but still possible with strong long-term care."
  }
};


function setStageProgress(data) {

  if (!data?.currentStage?.stage) return;

  const stageStr = data.currentStage.stage;        // e.g. "Stage-3"
  const stageNumber = Number(stageStr.match(/\d+/)[0]);   // 3
  const total = 6;

  // ========= Progress Ring =========
  const circle = document.querySelector('.fg-ring');
  if (circle) {
    const radius = 50;
    const circumference = 2 * Math.PI * radius;
    const filled = (stageNumber / total) * circumference;

    circle.style.strokeDasharray = `${circumference}`;
    circle.style.strokeDashoffset = `${circumference - filled}`;
  }

  // ========= Content Container =========
  const container = document.getElementById("dynamic-stage-description");
  if (!container) return;

  const geneticAnswer = data?.Recommendations?.Genetic;
  const allowed = ["Stage-2", "Stage-3", "Stage-4", "Stage-5"];

  if (geneticAnswer === "Yes" && allowed.includes(stageStr)) {

    const content = geneticStageContent[stageStr];
    if (!content) return;

    container.innerHTML = `
      <div class="genetic-box">
        <h3 class="genetic-headline">${content.headline}</h3>
        <ul class="genetic-list">
          ${content.text.map(t => `<li>${t}</li>`).join("")}
        </ul>
      </div>
    `;

  } else {

    container.textContent =
      stageDescriptions[stageStr]?.text ||
      stageDescriptions["Stage-2"].text;
  }
}

function successRateDataFetch(data) {
  const trigger = document.querySelector('.results-ui-update');
  const cliniclStudyNote = document.querySelectorAll('.clinical-study-note');
  const popup = document.getElementById('successrate-popup');
  const closeBtn = popup?.querySelector('.successrate-close');
  const contentBox = document.getElementById(
    'successrate--popup-content-placeholder'
  );
  const normalResultProgress = document.querySelector('.cstm-growthPossibilityBar.progress')
  const geneticAnswer = data?.Recommendations?.Genetic;
  const stage = data?.currentStage?.stage;
  const allowedStages = ["Stage-1", "Stage-2", "Stage-3", "Stage-4"];
  // if (caseId && !/^[0-7]/.test(caseId) && allowedStages.includes(stage)) {
    trigger?.classList.remove('d-none');
    cliniclStudyNote.forEach(el => { el.classList.remove('d-none');});
    normalResultProgress?.classList.add('d-md-block')
  // } else {
  //   normalResultProgress?.classList.remove('d-none')
  //   normalResultProgress?.classList.remove('d-md-block')
  // }
  if (!trigger || !popup || !contentBox || !closeBtn) return;

  let cachedHTML = '';
  let isReady = false;

  // 1️⃣ PREFETCH ON PAGE LOAD
  async function prefetchSuccessRatePage() {
    try {
      const res = await fetch('/pages/93-success-rate');
      if (!res.ok) throw new Error('Fetch failed');

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const pageContent =
        doc.querySelector('.page-width') ||
        doc.querySelector('main') ||
        doc.body;

      cachedHTML = pageContent.innerHTML;
      contentBox.innerHTML = cachedHTML;
      isReady = true;

      console.log('✅ Success rate page prefetched');
    } catch (err) {
      console.error('Prefetch failed:', err);
      contentBox.innerHTML =
        '<p>Unable to load content. Please refresh.</p>';
    }
  }

  // 2️⃣ OPEN POPUP (NO FETCH HERE)
  function openPopup() {
    if (!isReady) return; // safety
    popup.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  // 3️⃣ CLOSE POPUP
  function closePopup() {
    popup.classList.remove('show');
    document.body.style.overflow = '';
  }

  // Bind events
  trigger.addEventListener('click', openPopup);
  closeBtn.addEventListener('click', closePopup);

  popup.addEventListener('click', function (e) {
    if (e.target === popup) {
      closePopup();
    }
  });

  // 🔥 IMPORTANT: prefetch immediately
  prefetchSuccessRatePage();
}

// Checking Eligibility
function checkEligibility() {
  // Hide the checking container and show the loading container
  document.querySelector('.checking-container').style.display = 'none';
  document.querySelector('.loading-container').style.display = 'flex';
  
  // Simulate an API call with setTimeout
  setTimeout(() => {
    // Hide the loading container and show the eligibility result container
    document.querySelector('.loading-container').style.display = 'none';
    document.querySelector('.eligibilty-result').style.display = 'block';
  }, 1000); // Change the duration as needed
}
        
// doctor assigned section
function sectionCoach(response) {
  let stagesDoctorAssigned = response.currentStage;
  let assignedDoctor = document.querySelector('.doctor-assigned');
  let assignedDoctorPending = document.querySelector('.doctor-assigned--pending');
  const responseStage = stagesDoctorAssigned.stage; 
  
  if(assignedDoctor || assignedDoctorPending){
    // Check the value of responseStage and display the appropriate div
    if (responseStage === 'Stage-1') {
      assignedDoctor.style.display = 'block'; // or 'flex', depending on your layout
      assignedDoctorPending.style.display = 'none';
    } else {
      assignedDoctor.style.display = 'none';
      assignedDoctorPending.style.display = 'block'; // or 'flex', depending on your layout
    }
  }
}
 
// Function to determine if the device is mobile
function isMobileDevice() {
  return window.innerWidth <= 767;
}

function showProductDetails(productId, language) {
  if (!productId) {
    console.error('Product ID is undefined');
    return;
  }
  const tokens = {
    DEV: { 
      "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
    },
    PROD: { 
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    }
  };

  const nativeLink = {
    devLink: { 
      "siteLink": "public-zxhj2.dev.hav-g.in"
    },
    prodLink: { 
      "siteLink": "public-jgfas325.hav-g.in"
    }
  };

  fetch(`https://${nativeLink.prodLink.siteLink}/productContentv2/${productId}?language=${language}`, {
      headers: tokens.PROD // Using the DEV token as before
  })
  .then((response) => {
      if (!response.ok) {
          throw new Error('Network response was not ok');
      }
      return response.json();
  })
  .then((data) => {
      createProductPopup(productId);
  })
  .catch((error) => {
      console.error('Error fetching data:', error);
  });
}

// Function to create and display popup with product details
function createProductPopup(productId) {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  const popupContentPlaceholder = document.getElementById('popup-content-placeholder');
  const siteUrl = {
    dev: { 
      "Link": "formv2s.dev.hav-g.in"
    },
    prod: { 
      "Link": "form.traya.health"
    }
  };

  const iframeUrl = `https://${siteUrl.prod.Link}/product-drawerv2/${productId}`;
  
  // Load external product detail page into popup content placeholder
  popupContentPlaceholder.innerHTML = `
    <iframe src="${iframeUrl}" frameborder="0" width="100%" height="100%"></iframe>
  `;
  
  if (isMobileDevice()) {
    // Mobile view: popup from the bottom
    popup.style.bottom = '0';
  } else {
    // Desktop view: popup from the right
    popup.style.right = '0';
  }

  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
  
  // Close popup when close icon is clicked
  const closeIcon = document.querySelector('#product-popup #close-popup');
  closeIcon.addEventListener('click', function() {
    closeProductPopup();
  });

  // Close popup when overlay is clicked
  overlay.addEventListener('click', function() {
    closeProductPopup();
  });
}

// Function to close the popup
function closeProductPopup() {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  
  if (isMobileDevice()) {
    popup.style.bottom = '-100%';
  } else {
    popup.style.right = '-100%';
  }

  overlay.style.display = 'none';
  document.body.style.overflow = '';
}

// Function to add click event listener to month kit product cards
function addClickEventListernerToMonthkit() {
  document.querySelectorAll('.shopify-kit-section .kit-card-container').forEach((kit) => {
    kit.addEventListener('click', function (event) {
      const productId = event.currentTarget.getAttribute('data-product-id');
      const language = 'english'; // Assuming 'english' is the desired language
      showProductDetails(productId, language);
    });
  });
}

// Function to create the month kit section
function resultMonthKit(response) {
  const productData = response.product_Ids;
  const priceCart = response.cart_price
  
  const containerDiv = document.querySelector('.result-product-kit-wrapper');

  const header = document.createElement('h2');
  header.classList.add('kit-header', 'section-heading-font');
  header.innerText = 'Start your journey with just 1 month kit';
  containerDiv.appendChild(header);

  if(window.innerWidth <= 767){
    containerDiv.classList.remove('container');
  }

  const newSection = document.createElement('section');
  newSection.classList.add('shopify-kit-section');

  // new json data for the title and descritpion
  const updatedDataFromAPI = [
    {
      "variantId": "46528923304114",
      "name": "For Advanced Dandruff",
      "one_liner": "Advanced Anti-Dandruff Solution for stubbon dandruff"
    },
    {
      "variantId": "47329496826034",
      "name": "For Dandruff",
      "one_liner": "Anti-Dandruff Shampoo with proven actives"
    },
    {
      "variantId": "41645770309810",
      "name": "For Hair Regrowth",
      "one_liner": "Recap Serum with Hair Growth Actives"
    },
    {
      "variantId": "47329517568178",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 2% that prevents hormone led hair damage"
    },
    {
      "variantId": "47302891929778",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 5% that prevents hormone led hair damage"
    },
    {
      "variantId": "47301151064242",
      "name": "For Hair Hygiene",
      "one_liner": "Defence Shampoo for pH balance (SLS Free)"
    },
    {
      "variantId": "44650256728242",
      "name": "For Hair Texture",
      "one_liner": "Defence Conditioner for hydrated hair (SLS Free)"
    },
    {
      "variantId": "47276533121202",
      "name": "For Sleep",
      "one_liner": "Nasal Ghrit for restful sleep"
    },
    {
      "variantId": "46528902496434",
      "name": "For Digestion",
      "one_liner": "Gut Shuddi for constipation relief"
    },
    {
      "variantId": "46528906821810",
      "name": "For Hair Nutrition",
      "one_liner": "Hair Ras for hair nourishment"
    },
    {
      "variantId": "47303072710834",
      "name": "For Hairfall Control",
      "one_liner": "Hair Vitamin with natural hormone-blockers"
    },
    {
      "variantId": "47276523749554",
      "name": "For Metabolism",
      "one_liner": "Health Tatva for improved energy"
    },
    {
      "variantId": "46531537273010",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for scalp health"
    },
    {
      "variantId": "46530268987570",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for stress"
    },
    {
      "variantId": "46531521872050",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for hair growth"
    },
    {
      "variantId": "46530365751474",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for dandruff control"
    },
    {
      "variantId": "46528963936434",
      "name": "For Digestion",
      "one_liner": "Digest Boost for Gas and Bloating Relief"
    },
    {
      "variantId": "47302951403698",
      "name": "For Hair Nutrition",
      "one_liner": "Nourish Oil for adding shine to dull hair"
    },
    {
      "variantId": "47301148803250",
      "name": "For Hair texture",
      "one_liner": "Serum for Frizz-free, shiny hair"
    },
    {
      "variantId": "46465792704690",
      "name": "For Hair Nourishment",
      "one_liner": "Iron Santulan for deficiency triggered hair fall"
    },
    {
      "variantId": "47276517195954",
      "name": "For Stress",
      "one_liner": "Calm Ras to improve stress and sleep"
    },
    {
      "variantId": "47276531417266",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 2% that prevents hormone led hair damage"
    },
    {
      "variantId": "46465512898738",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 5% that prevents hormone led hair damage"
    },
    {
      "variantId": "44422009323698",
      "name": "For Hair Hygiene",
      "one_liner": "Defence Shampoo for pH balance (SLS Free)"
    },
    {
      "variantId": "47300731568306",
      "name": "For Hair Volume",
      "one_liner": "Serum with proven Hair Actives"
    },
    {
      "variantId": "47276511199410",
      "name": "For Digestion",
      "one_liner": "Consti Clear for improved digestion"
    },
    {
      "variantId": "47302757875890",
      "name": "For Stress, Metabolism & Digestion",
      "one_liner": "Hair Ras 01 for hair nourishment"
    },
    {
      "variantId": "47301161091250",
      "name": "For Stress, Metabolism & Digestion",
      "one_liner": "Hair Ras 02 for hair nourishment"
    },
    {
      "variantId": "46464896630962",
      "name": "For Stress, Metabolism & Digestion",
      "one_liner": "Hair Ras 05 for hair nourishment"
    },
    {
      "variantId": "47301139169458",
      "name": "For Stress & Metabolism",
      "one_liner": "Hair Ras 06 for hair nourishment"
    },
    {
      "variantId": "46464745308338",
      "name": "For Stress",
      "one_liner": "Hair Ras 09 for hair nourishment"
    }
  ];
  
  productData.forEach((each) => {
  const updated = updatedDataFromAPI.find(item => item.variantId === each.product_id);

  const displayName = updated ? updated.name : each.name;
  const displayOneLiner = updated ? updated.one_liner : each.oneLiner;

  const tagsArray = each.tag.tagKeyArray;
  let tagsHTML = '';
  if (tagsArray.length > 1) {
    tagsHTML = tagsArray.map(tag => `<p class="tag-title">${tag}</p>`).join('');
  } else {
    tagsHTML = `<p class="tag-title">${tagsArray[0]}</p>`;
  }

  const productDiv = document.createElement('div');
  productDiv.classList.add('kit-card-container');
  productDiv.dataset.productId = each.product_id;
  productDiv.innerHTML = `
      <div class="kit-card">
          <div class="box-separator-line">
              <div class="product-imge">
                  <img src="${each.image_url.singleImage}" width="80" height="80" />
              </div>
              <div class="product-description">
                  <div class="prod-heading">
                      <p class="prod-title">${displayName}</p>
                  </div>
                  <div>
                      <p class="prod-details">${displayOneLiner}</p>
                  </div>
                  <div>
                      <p class="prod-price">₹ ${Math.floor(each.price)}</p>
                  </div>
              </div>
              <div class="arrow">
                  <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.53255 7.03063L1.53255 12.0306C1.39165 12.1715 1.20056 12.2507 1.0013 12.2507C0.802043 12.2507 0.610947 12.1715 0.470051 12.0306C0.329155 11.8897 0.25 11.6986 0.25 11.4994C0.25 11.3001 0.329155 11.109 0.470051 10.9681L4.93943 6.5L0.471301 2.03063C0.401536 1.96086 0.346196 1.87804 0.308439 1.78689C0.270683 1.69574 0.25125 1.59804 0.25125 1.49938C0.25125 1.40072 0.270683 1.30302 0.308439 1.21187C0.346196 1.12072 0.401536 1.03789 0.471301 0.968128C0.541066 0.898364 0.623889 0.843023 0.715041 0.805267C0.806193 0.76751 0.903889 0.748077 1.00255 0.748077C1.10121 0.748077 1.19891 0.76751 1.29006 0.805267C1.38121 0.843023 1.46404 0.898364 1.5338 0.968128L6.5338 5.96813C6.60364 6.03789 6.65902 6.12075 6.69677 6.21196C6.73451 6.30316 6.75388 6.40093 6.75377 6.49964C6.75365 6.59835 6.73405 6.69606 6.69609 6.78718C6.65813 6.8783 6.60255 6.96103 6.53255 7.03063Z" fill="black"></path>
                  </svg>
              </div>
          </div>
          <hr class="block-line-separator d-none">
          <div class="tags tag-container d-none">
              <img src="${each.tag.icon}" alt="${each.tag.title}" class="d-none tag-icon">
              ${tagsHTML}
          </div>
      </div>
  `;
  newSection.appendChild(productDiv);

  // Add to cart logic
  if (getCookie("GuestForm_id")) {
    variantsIDs.push({
      'id': each.product_id,
      'quantity': 1,
      properties: {
        '_result_id': id
      }
    });
  } else {
    variantsIDs.push({
      'id': each.product_id,
      'quantity': 1
    });
  }
});

  containerDiv.appendChild(newSection);
  const firstSection = document.querySelectorAll('.hair_thinning_kit-container');
  if (firstSection && firstSection.parentNode) {
    firstSection.parentNode.insertBefore(containerDiv, firstSection.nextSibling);
  }
  addClickEventListernerToMonthkit();
}

// functionality for real stories
function sectionRealStories(response) {
  let { successStories } = response;
  if (successStories.showComponent == true) {
    const imgCarousel = document.querySelector('.image-carousel');
    const titleElement = document.querySelector('.stories-main-heading');
    const subTitleElement = document.querySelector('.stories-sub-heading');

    // Set title and subtitle
    titleElement.textContent = successStories.title;
    subTitleElement.textContent = successStories.subTitle;

    // Loop through each story to create image elements
    successStories.stories.forEach((storyUrl) => {
      const imgCarouselBlock = document.createElement('div');
      imgCarouselBlock.className = 'image-carousel-container';
      imgCarouselBlock.innerHTML = `
        <div class="image-carousel--container-img position-relative mx-2">
          <img src="${storyUrl.imageUrl}" alt="Success Story" height="auto" width="auto">
        </div>
      `;
      imgCarousel.appendChild(imgCarouselBlock);
    });

    // Initialize the Slick carousel after appending elements
    $(imgCarousel).slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true, 
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "15px",
            dots: true,
          },
        },
      ],
    });
  }
}

// doctor recomandation section 
function sectionBlocksDisplay(response) {
  let { stage_transition } = response;
  let stage = stage_transition.currentStage.stage;
  const apiSection = document.querySelector('.static-block-container');
  const staticSection = document.querySelector('.block-container');

  const isDesktop = window.matchMedia('(min-width: 768px)').matches;

  if (stage === 'Stage-1') {
    apiSection.style.display = 'none';
    staticSection.style.display = isDesktop ? 'flex' : 'block';
  } else {
    apiSection.style.display = isDesktop ? 'flex' : 'block';
    staticSection.style.display = 'none';
  }
}
// doctor recomandation section end

// custom price 
function customPriceSection(response) {
  let cartPrice = response.cart_price;
  cartPrice = parseFloat(cartPrice).toFixed(2);
    if (cartPrice.endsWith('.00')) {
      cartPrice = parseInt(cartPrice);
    }

  let slashPrice = cartPrice + 500;

  const dynamicPriceElements = document.querySelectorAll('#dynamic-price');
  if (dynamicPriceElements.length > 0) {
    dynamicPriceElements.forEach(element => {
      element.innerHTML = cartPrice;
    });
  } else {
    console.error('Price elements not found');
  }

  const slashPriceElement = document.getElementById('slash-price');
  if (slashPriceElement) {
    slashPriceElement.innerHTML = `₹${slashPrice}`;
  } else {
    console.error('Slash price element not found');
  }
}
// end of custom price

// timeline section 
function sectionMonthsExpectetion(response) {
  let { monthsExpectation } = response;
  if (monthsExpectation.showComponent == true) {
    const timeline = document.getElementById('timeline');
    const weeksUpdateElement = document.querySelector('.weeks-update')
    weeksUpdateElement.innerHTML = monthsExpectation.months;
    monthsExpectation.monthExpectations.forEach((month, index) => {
        const block = document.createElement('div');
        block.className = 'timeline-block';
        block.innerHTML = `
            <div class="timeline-icon">
              <img src="${month.image_url}" alt="Month ${month.month}" width="100" height="100">
            </div>
            ${index < monthsExpectation.monthExpectations.length - 0 ? `
              <div class="timeline-dot-line">
                <div class="timeline-dot"></div>
                <div class="timeline-line"></div>
              </div>
            ` : ''}
            <div class="timeline-content">
              <p><strong>Month ${month.month}</strong></p>
              <p>${month.goal}</p>
            </div>
        `;
       timeline.appendChild(block);
    });
    if(window.innerWidth > 767){
      $(timeline).slick({
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              centerMode: true,
              centerPadding: "15px",
            },
          },
        ],
      });
    }
  }
}

function moneyBackPolicy(){
  const handle = 'money-back-policy';
  fetch(`/pages/${handle}.js`)
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json(); // Assuming the response is JSON
  })
  .then(data => {
    console.log(data);
  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });
}

function rootCause (response) {
  const primaryRootCause = response?.primaryRootCause ?? [];
  const defaultRootCause = response?.defaultRootCause ?? [];
  let primaryRootCauseHtml = '';
  let primaryRootCauseContentHtml = '';
  if (primaryRootCause.length > 0) {
    primaryRootCauseHtml = `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border active text-center" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tab" aria-controls="${primaryRootCause[0]?.title.replace(/ /g, "-")}" aria-selected="true">
        <div class="rootCauseLinkImg">
          <img src="${primaryRootCause[0]?.details?.icon}" width="auto" height="auto"/>
        </div>
        <div class="primary-tag-flex">
          <p class="mt-2">${primaryRootCause[0]?.title}</p>
          <p class="primary-tag d-none">Primary</p>
        </div>
      </a>
    </li>`;
  }
  if (primaryRootCause.length > 0) {
    primaryRootCauseContentHtml = `<div class="tab-pane fade show active" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${primaryRootCause[0]?.details?.description?.english}</p>
    </div>`;
  }
  const defaultRootCauseHtml = defaultRootCause.map((item) => {
    return `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border text-center" id="${item?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${item?.title.replace(/ /g, "-")}" role="tab" aria-controls="${item?.title.replace(/ /g, "-")}" aria-selected="false">
        <div class="rootCauseLinkImg">
          <img src="${item?.details?.icon}" width="auto" height="auto"/>
        </div>
        <div class="primary-tag-flex">
          <p class="mt-2">${item?.title}</p>
          <p class="primary-tag d-none">Primary</p>
        </div>
      </a>
    </li>`;
  }).join('');
  const defaultRootCauseContentHtml = defaultRootCause.map((item) => {
    return `<div class="tab-pane fade" id="${item?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${item?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${item?.details?.description?.english}</p></div>`;
  }).join('');
  const rootCauseHtml = `<ul class="nav rootCause-nav-tabs border-0" id="myTab" role="tablist">${primaryRootCauseHtml}${defaultRootCauseHtml}</ul>
  <div class="tab-content rootCauseTabContent p-2 p-md-3 mt-3" id="myTabContent">${primaryRootCauseContentHtml}${defaultRootCauseContentHtml}</div>`;
  const rootCauseSectionWrapper = document.getElementById('rootCouseSectionWrapper');
  if (rootCauseSectionWrapper) {
    rootCauseSectionWrapper.innerHTML = rootCauseHtml;
    const urlParams = new URLSearchParams(window.location.search);
    const rootcauseFromURL = urlParams.get("rootcause");
    const primaryTitle = primaryRootCause?.[0]?.title.toLowerCase();
    const primaryTagEl = rootCauseSectionWrapper.querySelector(".primary-tag");
    console.log(rootcauseFromURL, 'rootcauseFromURL', primaryTitle, 'primaryTitle')
    if (rootcauseFromURL && primaryTitle && rootcauseFromURL === primaryTitle) {
      primaryTagEl?.classList.remove("d-none");
    } else {
      primaryTagEl?.classList.add("d-none");
    }
  }
}

// functionality for customer result male
function displayStageSection(response) {
  const stageImages = {
    "Stage-1": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage-1-img1.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img2.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img3.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stgae1-img4.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img5.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img6.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img7.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img8.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img9.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img10.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img11.webp?v=1749470793"
      ],
      customerName: "Prashant"
    },
    "Stage-2": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-1.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-2.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-3.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-4.webp?v=1749473384",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-5.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-6.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-7.webp?v=1749473383"
      ],
      customerName: "Abhishek"
    },
    "Stage-3": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image.webp?v=1749474168",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-1.webp?v=1749474168",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-2.webp?v=1749474169",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-3.webp?v=1749474168",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-4.webp?v=1749474169",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-5.webp?v=1749474168"
      ],
      customerName: "Vaibhav"
    },
    "Stage-4": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-1.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-2.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-3.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-4.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-5.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-6.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-7.webp?v=1749474703",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-8.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-9.webp?v=1749474705"
      ],
      customerName: "Prem"
    },
    "Stage-5": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-1.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-2.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-image-3.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-4.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-5.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-image-6.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-7.webp?v=1749475547"
        
      ],
      customerName: "Anand"
    },
    "Heavy Hair Fall": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/heavy-hair-fall-Image.png?v=1749476011",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-1.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-2.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-3.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-4.png?v=1749476011",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-5.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-6.png?v=1749476011",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-7.png?v=1749476010"
      ],
      customerName: "Gopal"
    },
    "Coin Size Patch": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-1.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-2.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-3.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-4.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-5.webp?v=1749476276"
      ],
      customerName: "Darshit"
    }
  };

  const userStage = response.User_Analysis.stage;
  const stageData = stageImages[userStage];
  console.log("User stage from response:", userStage);

  const stageContainer = document.getElementById("stageContainer");
  stageContainer.innerHTML = ""; 
  
  if (stageData && stageData.images.length > 0) {
    const p1 = document.createElement("p");
    p1.textContent = `Here is ${stageData.customerName}`;
    p1.className = "custome-stage-heading";
    stageContainer.appendChild(p1);

    const p2 = document.createElement("p");
    p2.textContent = "Who Matches Your Profile";
    p2.className = "custome-stage-subheading";
    stageContainer.appendChild(p2);

    const imageWrapper = document.createElement("div");
    imageWrapper.className = "stage-image-wrapper";

    stageData.images.forEach((imgUrl) => {
      const img = document.createElement("img");
      img.src = imgUrl;
      img.alt = userStage;
      img.className = "scrollable-stage-image"; 
      img.loading = "lazy"; 
      imageWrapper.appendChild(img);
    });

    stageContainer.appendChild(imageWrapper);
  }
}

function displayProduct(response) {
  var resp = Object.assign(response.User_Analysis, response.Recommendations);
  f_name = resp.first_name;
  C_number = resp.phone;
  C_email = resp.email;
  user__gender = resp.gender;
  setCookie('user_phone', C_number, 30);
  caseId= resp.case_id;
  localStorage.setItem('caseId', caseId);
  var gmpNote = document.querySelector('.gmp-certified-strip');
  if (gmpNote) gmpNote.classList.remove('d-none');
  var stickyBtn = document.getElementById('sticky-btn');
  if (stickyBtn) stickyBtn.style.boxShadow = 'none';
  if(user__gender == 'M') {
    user_gender = 'Male';
  }
  var coin_size = false;
  if(resp.stage == 'Coin Size Patch') {
    coin_size = true;
  }
  var productTemplate = 'result-product-list', slides = 1, mobileSlides = 1 ,arrows = false, dots = true;
  if(resp.stage == "Stage-1") {
    productTemplate = 'result4c-card', slides = 3, mobileSlides = 1.3;
  }else {
    productTemplate = 'result4c-card', slides = 3, mobileSlides = 1.3;
    // productTemplate = 'result-product-list', slides = 1, mobileSlides = 1;
  }
  var test_result = document.querySelectorAll('.test-result'), sticky_btn = document.querySelectorAll('.sticky-btn'), 
  transplant_stage_six = document.querySelectorAll('.transplant-stage-six'), normal_page_is = true;
  var  stageDescription_text = document.querySelectorAll('.stageDescription_text'),
  user_type_stage = document.querySelectorAll('.user_type_stage'), diagnosed_text = document.querySelectorAll('.diagnosed_text'),
  productKitSection = document.querySelectorAll('.kit-container'), doctorsSection = document.querySelectorAll('.section-coach.container'),
  timelineSection = document.querySelectorAll('.timeline--container'), priceBreakStage = document.querySelectorAll('.custom-price-section'),
  eligibilityCheck = document.querySelectorAll('.eligibility-check--section'), faqSection = document.querySelectorAll('.aldrich-faq');
  if(resp.gender == 'M' && resp.stage == "Stage-6"){
    document.querySelector('body.result4c').style.width = '100%';
    document.querySelector('body.result4c #MainContent').style.padding = 0;
    normal_page_is = false;
  }else{
    normal_page_is = true;
  }
  if(test_result.length != 0) {
    test_result.forEach((result) => {
      if(normal_page_is == false) {
        result.classList.add('d-none');
      }else {
        result.classList.remove('d-none');
      }
    })
  }
  if(productKitSection.length != 0) {
    productKitSection.forEach((kit) => {
      if(normal_page_is == false) {
        kit.classList.add('d-none');
        const futureKitSection = document.querySelector('.future-kit-routine');
        if(futureKitSection) futureKitSection.style.display = 'none';
      }else {
        kit.classList.remove('d-none');
      }
    })
  }
  if(doctorsSection.length != 0) {
    doctorsSection.forEach((doctors) => {
      if(normal_page_is == false) {
        doctors.classList.add('d-none');
      }else {
        doctors.classList.remove('d-none');
      }
    })
  }
  if(timelineSection.length != 0) {
    timelineSection.forEach((time) => {
      if(normal_page_is == false) {
        time.classList.add('d-none');
      }else {
        time.classList.remove('d-none');
      }
    })
  }
  if(priceBreakStage.length != 0) {
    priceBreakStage.forEach((priceBreak) => {
      if(normal_page_is == false) {
        priceBreak.classList.add('d-none');
      }else {
        priceBreak.classList.remove('d-none');
      }
    })
  }
  if(eligibilityCheck.length != 0) {
    eligibilityCheck.forEach((check) => {
      if(normal_page_is == false) {
        check.classList.add('d-none');
      }else {
        check.classList.remove('d-none');
      }
    })
  }
  if(faqSection.length != 0) {
    faqSection.forEach((faq) => {
      if(normal_page_is == false) {
        faq.classList.add('d-none');
      }else {
        faq.classList.remove('d-none');
      }
    })
  }
  if(sticky_btn.length != 0) {
    sticky_btn.forEach((section) => {
      if(normal_page_is == false) {
        section.classList.add('d-none');
      }else {
        section.classList.remove('d-none');
      }
    });
  }
  if(transplant_stage_six.length != 0) {
    transplant_stage_six.forEach((section) => {
      if(normal_page_is == false) {
        section.classList.remove('d-none');
      }else {
        section.remove();
      }
    });
  }
  if (trayaProcessingAnimation) {
    trayaProcessingAnimation.style.display = 'none';
  }  
    
  // Recommended Products End
  let stageDitection = document.querySelectorAll('#stage');
  if (resp.stage == "Stage-1") {
    stageDitection.forEach((stage) => { stage.innerHTML = 'Stage 1' });
  }else if (resp.stage == "Stage-2") {
    stageDitection.forEach((stage) => { stage.innerHTML = 'Stage 2' });
  }else if(resp.stage == "Stage-3"){
    stageDitection.forEach((stage) => { stage.innerHTML = 'Stage 3' });
  }else if(resp.stage == "Stage-4"){
    stageDitection.forEach((stage) => { stage.innerHTML = 'Stage 4' });
  }else if(resp.stage == "Stage-5"){    
    stageDitection.forEach((stage) => { stage.innerHTML = 'Stage 5' });
  }
  document.body.style.overflow = 'unset';
}

function getProductByHandle(response) {
  let femaleResultBuyBtn = document.querySelectorAll('#add-to-cart-result-page');
  let resultTotalPrice = document.querySelectorAll('.total-price');
  let sticky_slash_price_element = document.getElementById('sticky-slash-price');
  const finalCartPrice = Math.round(response.cart_price);
  
  if (resultTotalPrice.length !== 0) {
    resultTotalPrice.forEach((price) => {
      price.innerHTML = `₹ ${finalCartPrice}`;
    });
  }
  
  if (sticky_slash_price_element) {
    sticky_slash_price_element.innerHTML = `₹ ${finalCartPrice + 500}`;
  }

  if(femaleResultBuyBtn.length != 0) {
    femaleResultBuyBtn.forEach((buyBtn) => {
      buyBtn.setAttribute('data-price', prices);
    })
  }
  applyOneMonthDiscount(response);
}
function applyOneMonthDiscount(response) {
  const discountsData = response?.discounts;
  if (!discountsData) return;

  if (!discountsData.discountValidityByPlan?._1Month) return;
  const discountObj = discountsData.discount?.[0];
  if (!discountObj) return;

  const { code, value, validCartValue } = discountObj;
  if (!code || !value || !validCartValue) return;

  const cartTotal = Math.round(response.cart_price);
  if (cartTotal < validCartValue) return;
  
  let discountAmount = 0;
  if (discountObj.type === 'percentage') {
    discountAmount = Math.round((cartTotal * value) / 100);
  } else {
    discountAmount = value;
  }
  const discountedTotal = Math.max(cartTotal - discountAmount, 0);

  const strikeoutPriceAfterDiscount = discountedTotal + 500;
  // UI price updates
  document.querySelectorAll('.strike-cart-total-price').forEach(el => {
    el.innerHTML = `₹ ${strikeoutPriceAfterDiscount}`;
  });

  document.querySelectorAll('.total-price').forEach(el => {
    el.innerHTML = `₹ ${discountedTotal}`;
  });

  const stickySlash = document.getElementById('sticky-slash-price');
  if (stickySlash) {
    stickySlash.innerHTML = `₹ ${strikeoutPriceAfterDiscount}`;
  }

  // Show referral applied UI
  document.querySelectorAll('.refferal-discount-applied').forEach(el => {
    el.classList.remove('d-none');
  });

  // ✅ ONLY store the code
  window.appliedReferralCode = code;
}

function updateCartDrawer() {
  // Step 1: Get current cart contents
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const updates = {};

      cart.items.forEach(item => {
        if (item.quantity === 2) {
          updates[item.key] = 1; // Reduce quantity to 1 if it is exactly 2
        }
      });

      // Step 2: If any item needs update, call /cart/update.js in bulk
      if (Object.keys(updates).length > 0) {
        const body = {
          updates: updates
        };

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        })
        .then(res => res.json())
        .then(() => {
          // Step 3: Proceed to update UI (cart bubble + drawer)
          refreshCartUI();
        })
        .catch(err => console.error('Error updating quantities:', err));
      } else {
        // No updates needed, just refresh UI
        refreshCartUI();
      }
    });
}

function bindCartDrawerEvents() {
  const closeBtn = document.querySelector('.drawer__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      document.querySelector('cart-drawer.drawer')?.classList.remove('active');
      document.querySelector('.cart-drawer__overlay')?.classList.remove('active');
    });
  }
}

function refreshCartUI() {
  // Update cart bubble
  fetch('/?sections=cart-icon-bubble')
  .then(res => res.json())
  .then(data => {
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && data['cart-icon-bubble']) {
      cartIconBubble.innerHTML = data['cart-icon-bubble'];
    }
  });

  // Update cart drawer section
  fetch('/?sections=cart-drawer')
  .then(res => res.json())
  .then(data => {
    const cartDrawerHTML = data['cart-drawer'];
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawerHTML) {
      cartDrawer.outerHTML = cartDrawerHTML;

      // Rebind events AFTER new drawer is in DOM
      setTimeout(() => {
        bindCartDrawerEvents?.();
      }, 50);

      // Optional: Hide quantity and remove button
      document.querySelectorAll('.cart-drawer .cart-item cart-remove-button, .cart-drawer quantity-input.quantity').forEach(el => {
        el.style.display = 'none';
      });    
    }
  })
  .catch(err => console.error('Error updating cart drawer:', err));
}

function checkout() {
  localStorage.setItem('user__gender',user_gender);
  localStorage.setItem('caseId',caseId);
  if(user__gender == 'M') {
    user_gender = 'Male';
  }
  variantsIDs.forEach((e) => {
    if(e.id === 37681124081842){
      e.properties = {'Plan': 'Dandruff'};
    }else if(e.id === 42648509186226){
      e.properties = {'Plan': 'Dandruff'};
    }else if(e.id === 41899898011826){
      e.properties = {'Plan': 'Dandruff'};
    }else {
      e.properties = {'Plan': 'Auto'};
    }
  });
  let formData = {
    'items': variantsIDs,
    sections: 'cart-drawer',
    attributes: {
      first_name: f_name,
      phone: C_number,
      email: C_email,
      user__gender: user_gender,
      caseid: caseId
    }
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {  
    localStorage.setItem('User_location', "cart");
    return response.json();
  }).then(result => { 
    var t = document.querySelector('cart-drawer');
    let cart_drawer = result.sections['cart-drawer'];
    CartDrawerUpdate(t, cart_drawer);
  }).catch((error) => {
    console.error('Error:', error);
  }).finally(() => {
    updateCartDrawer();
    cartData();
    var atcButton2 = document.querySelector('#add-to-cart-result-page');
    // atcButton2.classList.remove('loader-added')
    atcButton2.disabled = false;
  });
}

async function fireEvent(eventName, caseID, attributes = {}) {
  const MoEngageAPI = {
    DEV: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  const bearerTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };

  // These are always sent, your custom attributes get merged in
  const defaultAttributes = {
    platform: "web_shopify",
    domain: "traya.health",
    URL: window.location.href,
    syntheticId: new URLSearchParams(window.location.search).get('id') || "default-id"
  };

  const response = await fetch(`${MoEngageAPI.PROD}eventMoengageWeb`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...bearerTokens.PROD
    },
    body: JSON.stringify({
      eventName,
      eventAttributes: {
        generalAttributes: {
          ...defaultAttributes,  // always included
          ...attributes          // your custom ones, also overrides defaults if needed
        }
      },
      caseId: caseID
    })
  });
}

function ShowContent(response) {
  var data = Object.assign(response.User_Analysis, response.Recommendations);
  let stageDescription = response.stageWiseDescription.english;
  var growthPossibility = response.growthPossibilityBar;
  var maxMonth = response.Recommendations.Max_months;
  var grothBar = document.querySelector(".cstm-growthPossibilityBar")
 var treatedCount = response.treatedCXCount.description.replace('*', '');
  var treatedCountDOM = document.querySelector(".customer-based-profile");
  var treatmentDuration = document.querySelector(".traetment-duration");
  treatmentDuration.innerText = `${maxMonth} Months`;
  FutureKitRoutine(maxMonth);
  if (treatedCountDOM) treatedCountDOM.innerText = treatedCount;
  var illness = data.experienced_in_one_year, genetics = data.Genetic, userStage = data.stage;
  var userName = document.querySelectorAll('[data-user-name]'), name1 = document.querySelectorAll('#name1'),
  name3 = document.querySelectorAll('#name3'), stage1 = document.querySelectorAll('#stage1'),
  typeOfLoss3 = document.querySelectorAll('#typeOfLoss3'), stage3 = document.querySelectorAll('#stage3'),
  stageDescriptionMain = document.querySelectorAll('#stageDescription'), stage3 = document.querySelectorAll('#stage3'),
  typeOfLoss = document.querySelectorAll('#typeOfLoss'), mainstage = document.querySelectorAll('#stage');
  var ourdia = document.querySelector('#ourdia'), stagesnames = document.querySelectorAll('.stages-name');
  var stageImage = response?.currentStage?.imgUrl;
  if(growthPossibility == true){grothBar.style.display = "block";}
  if(userName.length != 0) { userName.forEach((name) => { name.innerHTML = `${data.first_name}` }) }
  if(name1.length != 0) { name1.forEach((name) => { name.innerHTML = `${data.first_name}` }) }
  if(name3.length != 0) { name3.forEach((name) => { name.innerHTML = `${data.first_name}` }) }
  if(stage1.length != 0) { stage1.forEach((stage) => { stage.innerHTML = `${data.stage?.replace(/-/g, ' ')}` }) }
  if(typeOfLoss3.length != 0) { typeOfLoss3.forEach((loss) => { loss.innerHTML = `${data.Type_of_hair_loss}` }) }
  if(stage3.length != 0) { stage3.forEach((stage) => { stage.innerHTML = `${data.stage?.replace(/-/g, ' ')}` }) }
  if(stageDescriptionMain.length != 0) { 
    stageDescriptionMain.forEach((stage) => { 
      stage.innerHTML = `${stageDescription}`; 
    })
  }
  if(illness.length != 0) {
    var TECondition = illness.filter((ill) => {
      if(ill == 'Severe Illness (Dengue, Malaria, Typhoid or Covid)') {
        return ill;
      }
    })
    if(TECondition.length == 1 && (genetics == 'Yes' || genetics == 'No') && (userStage == 'Heavy Hair Fall Across The Head' || userStage == 'Heavy Hair Fall')) {
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `Heavy Hair Fall`; }) }
      // if(mainstage.length != 0) { mainstage.forEach((stage) => { stage.innerHTML = `${data.stage.replace(/-/g, ' ')}` }) }
    }else if(TECondition.length == 0 && genetics == 'Yes' && (userStage == 'Heavy Hair Fall Across The Head' || userStage == 'Heavy Hair Fall')) {
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `Male Pattern Hair Loss`; }) }
    }else if(TECondition.length == 0 && genetics == 'No' && (userStage == 'Heavy Hair Fall Across The Head' || userStage == 'Heavy Hair Fall')) {
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `Heavy Hair Fall`; }) }
      if(mainstage.length != 0) { mainstage.forEach((stage) => { stage.innerHTML = `${data.stage.replace(/-/g, ' ')}` }) }
    } else if(userStage == 'Coin Size Patch'){
        if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `Coin Size Patches`; }) }
    } else if(data.Type_of_hair_loss == 'Male Pattern Hair Fall'){
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `Of Male Pattern Hair Fall`; }) }
    }else {
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `${data.Type_of_hair_loss}`; }) }
    }
  }
  /* Dandruff Response */
  var dandruffResp = response.User_Analysis.dandruff_response;
  
  if(userStage != 'Stage-6') {
    if(dandruffResp == 'Yes, heavy dandruff that sticks to the scalp') {
      let stageElement = document.querySelector('.male_pcos_causing_main');
      if(stageElement){
        document.querySelector('.male_pcos_causing_main').style.display = 'block';
      }
    }
  }

  /* 3 Sections on All Stages Except Stage6 & Coin Size Patch Changes */
  if(userStage == 'Stage-6') {
      let stage6plan = document.querySelector('.male-treatment-plan');
      let stage6plan2 = document.querySelector('.aldrich-faq');
      if(stage6plan && stage6plan2){
        document.querySelector('.male-treatment-plan').style.display = 'none';
        document.querySelector('.aldrich-faq').style.display = 'none';
      }
    }
  
  if(userStage != 'Stage-6') {
    let userStage6plan = document.querySelector('.stage1-doctors');
    if(userStage6plan){
      document.querySelector('.stage1-doctors').style.display = 'block';
    }
  }
  
  selectedStage = data.stage;
  document.querySelector(`.${selectedStage}`)?.classList.add('selectedStage');
  if (selectedStage === 'Stage-1') {
    // document.querySelector('.Stage-1')?.classList.add('all-stages');
    // document.querySelector('.main-stage-section')?.classList.add('all-stages-pd');
  } else if (selectedStage === 'Stage-2') {
    document.querySelector('.Stage-2-1')?.classList.add('checkStage');
  } else if (selectedStage === 'Stage-3') {
    document.querySelector('.Stage-3-1')?.classList.add('checkStage');
  } else if (selectedStage === 'Stage-4') {
    document.querySelector('.Stage-4-1')?.classList.add('checkStage');
  } else if (selectedStage === 'Stage-5') {
    document.querySelector('.Stage-5-1')?.classList.add('checkStage');
  } else if (selectedStage === 'Stage-6') {
    document.querySelector('.Stage-5')?.classList.add('checkStage');
  } else if (selectedStage === 'Coin Size Patch') {
    document.querySelector('.Stage-7')?.classList.add('selectedStage');
  } else if (selectedStage === 'Heavy Hair Fall Across The Head' || selectedStage === "Heavy Hair Fall") {
    document.querySelector('#male-stages')?.classList.add('male-stagesTE');
    document.querySelector('.TE_stage-name').style.display = "none";
    document.querySelector('#stageDescription')?.classList.add('stageDescriptionTE');
    document.querySelector('.Stage-8')?.classList.add('selectedStage');
    document.querySelector('.Stage-8-1')?.classList.add('checkStage', 'hide-text');
  }
  var __selectedStage = document.querySelectorAll(".selectedStage");
  if(__selectedStage.length) {
    __selectedStage.forEach((stage) => {
      var imageField = stage.querySelector("img");
      if(imageField && stageImage) imageField.setAttribute("src", stageImage);
    })
  }
  var diagnoses__image =  document.querySelector('.diagnoses-result > img');
  if(diagnoses__image) { diagnoses__image.style.display = 'none'; }
  if(ourdia) {
    var ourdia__li = ourdia.querySelectorAll('li');
    ourdia__li.forEach((li) => {
      li.style.display = 'none';
    });
    var ourdia__btns = ourdia.querySelectorAll('a');
    if(ourdia__btns.length != 0) {
      ourdia__btns.forEach((btns) => {
        btns.addEventListener('click', function(e) {
          e.preventDefault();
          var id = this.getAttribute('data-id'), tab_panes = document.querySelectorAll('.tab-pane'),
          nav__links = document.querySelectorAll('.nav-item.nav-link');
          tab_panes.forEach((pane) => {
            pane.classList.remove('active');
            pane.classList.remove('show');
          });
          document.querySelector(`#nav-tabContent #${id}`).classList.add('active');
          document.querySelector(`#nav-tabContent #${id}`).classList.add('show');
          nav__links.forEach((links) => {
            links.classList.remove('active');
          });
          document.querySelector(`#nav-tab #${id}-tab`).classList.add('active');
        });
      });
    }
  }
  if(stagesnames.length) {showOrHide(stagesnames, "none");}
  var __selectedStage = document.querySelectorAll(".selectedStage");
  if(__selectedStage.length) {
    __selectedStage.forEach((stage) => {
      var imageField = stage.querySelector("img");
      if(imageField && stageImage) imageField.setAttribute("src", stageImage);
    })
  }
  var atcButtonRP4 = document.querySelectorAll('#add-to-cart-result-page'),
  stickyAtcButtonRP4 =  document.querySelectorAll('.sticky-btn #add-to-cart-result-page');
  if(atcButtonRP4.length != 0) {
    atcButtonRP4.forEach((btn) => {
      btn.setAttribute('user-mobile', data.phone);
      btn.setAttribute('user-email', data.email);
    });
  }
  if(stickyAtcButtonRP4.length != 0) {
    stickyAtcButtonRP4.forEach((btn) => {
      btn.setAttribute('user-mobile', data.phone);
      btn.setAttribute('user-email', data.email);
    });
  }
  // buy now click cpi event
  let buyButtonElements = document.querySelectorAll('#add-to-cart-result-page');
  buyButtonElements.forEach((eachBtn) => {
      eachBtn.addEventListener('click', () => {
          console.log('MetaCapi');
          trackMetaEvent(response.User_Analysis, "Expand Benefits");
          fireEvent("buy_now", caseId, {
            syntheticId: window.location.search.substring(1).split('=')[1] || "default-id",
            language: "english"
          });
      });
  });
}

// ===== Future Kit Routine Switcher =====
function FutureKitRoutine(maxMonths) {

  const section = document.querySelector('[id^="future-kit-routine-"]');
  if (!section) return;

  const deskImg = section.querySelector('.future-kit-img--desk');
  const mobImg  = section.querySelector('.future-kit-img--mob');

  // Bundle → images mapping (YOU control this)
  const FUTURE_KIT_IMAGES = {
    5: {
      desk: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_3_f85dfd3e-2878-45c7-aad9-d67a6429ff7b.webp',
      mob:  'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_2_fed1e1e3-5163-43dc-bce4-070ebac97d40.webp'
    },
    8: {
      desk: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_5.webp?v=1766991051',
      mob:  'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_4_b96d31a7-587c-489d-960a-a7e0b8b7e8eb.webp'
    },
    12: {
      desk: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_8.webp',
      mob:  'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_7.webp'
    }
  };

  if (!maxMonths || !FUTURE_KIT_IMAGES[maxMonths]) {
    console.warn('FutureKitRoutine: invalid maxMonths', maxMonths);
    return;
  }

  deskImg.src = FUTURE_KIT_IMAGES[maxMonths].desk;
  mobImg.src  = FUTURE_KIT_IMAGES[maxMonths].mob;
}

document.addEventListener("DOMContentLoaded", function () {
  var atcButton2 = document.querySelector('#add-to-cart-result-page');
  // atcButton2.classList.add('loader-added')
  atcButton2.disabled = true;
  const listItems = document.querySelectorAll(".f-b-main-li");
  const anchorLinks = document.querySelectorAll(".nav-link");
  const tabLinks = document.querySelectorAll(".tab-pane");

  listItems.forEach(function (item) {
    item.addEventListener("click", function () {
      const target = this.getAttribute("data-targets");
      triggerAction(target);
    });
  });

  function triggerAction(target) {
    anchorLinks.forEach(function (link) {
      if (link.getAttribute("data-targets") === target) {
        anchorLinks.forEach(function (link) {
          link.classList.remove("active");
        });
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });

    tabLinks.forEach(function (tab) {
      if (tab.getAttribute("data-targets") === target) {
        tabLinks.forEach(function (tab) {
          tab.classList.remove("active");
          tab.classList.remove("show");
        });
        tab.classList.add("active");
        tab.classList.add("show");
      } else {
        tab.classList.remove("active");
        tab.classList.remove("show");
      }
    });
  }
  let buyNowBtnElement = document.querySelectorAll('#add-to-cart-result-page');
  buyNowBtnElement.forEach((buyBtnEach)=>{
    buyBtnEach.addEventListener('click', function(){
      // console.log('how many clicks?');
    })
  })
});

function cartData() {
  window.dataLayer = window.dataLayer || [];
  function gtag(){
    dataLayer.push(arguments);
  }
  fetch("/cart.js").then((cart) => {
    return cart.json();
  }).then((cart) => {
    var items = [];
    cart.items.forEach((item) => {
      items.push({
        "item_id": item.id,
        "item_name": item.title,
        "item_brand": "Traya Health",
        "item_category": "",
        "price": (parseInt(item.price) / 100),
        "quantity": item.quantity
      })
    });
    var eventData = {
      "currency": cart.currency,
      "value": (parseInt(cart.items_subtotal_price) / 100),
      "items": items
    };
    gtag("event", "view_cart", eventData);
  }).catch((error) => {
    console.error("Error: ", error);
  })
}

function showOrHide(partition, state) {
  partition.forEach((part) => {
    part.style.display = `${state}`;
  })
}